import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import BooksSection from './components/BooksSection';
import ContactSection from './components/ContactSection';
import { useMeta } from './hooks/useMeta';
import { Analytics } from "@vercel/analytics/react";

function App() {
  useMeta({
    title: 'Inmaculada Fuentes - Autora de libros infantiles',
    description: 'Descubre los libros de Inmaculada Fuentes: Mimadre, EOS y Gaia. Álbumes ilustrados educativos, solidarios y respetuosos con el medio ambiente.',
    image: '/biografia.png',
    url: 'https://inmaculadafuentes.com'
  });

  return (
    <div className="app">
      <Navbar />
      <HeroSection />
      <BooksSection />
      <AboutSection />
      <ContactSection />
      <Analytics />
    </div>
  );
}

export default App;